import { h } from 'preact';
import * as BaseComp from 'components/bolt/tiledItems/tiledItems.js';
import { joinClasses } from 'utils/utils';
import { getDynamicData } from 'utils/bolt/dynamicData';
import Store from 'store/store';

import HTML from 'components/core/html/html';

import s from 'components/bolt/tiledItems/tiledItems.sss';

export default class TiledItems extends BaseComp.default {
	async componentDidMount() {
		super.componentDidMount();
		const { appData } = this.props;
		const activePage = Store.get().activePage || this.props.id;
		if (appData?.options?.cmsManaged && activePage === 'careers') {
			try {
				this.useCustomData(await getDynamicData('careers'));
				this.getTilesArray();
			} catch (e) {
				console.error("Failed to load careers data", e);
			}
		}
	}

	useCustomData(dynamicData) {
		if (!dynamicData) return;

		const tiles = (dynamicData.tiledItems || []).map((tile, i) => ({
			title: tile.title,
			description: tile.subtitle,
			body: tile.body,
			ctaButtons: tile.buttons || [],
			order: i + 1,
		}));

		this.dynamicData = {
			title: dynamicData.title || '',
			description: dynamicData.description || this.props.data?.description,
			tiles,
		};
		
		this.forceUpdate();
	}

	getTilesArray() {
		if (!this.dynamicData) {
			return super.getTilesArray();
		}

		const dynamic = this.dynamicData.tiles;
		if (dynamic.length === 0) {
			this.setState({ tilesArray: [] });
			return;
		}

		const tilesArray = this.splitTiles([
			{
				tilesData: dynamic.map(tile => ({
					...tile,
					ctaButtons: tile.buttons || tile.ctaButtons || [],
				})),
				orientation: 'landscape',
			}
		]);
		this.setState({ tilesArray });
	}

	renderTitle() {
		const content = this.dynamicData?.title || this.props.data?.title;
		return <HTML class={joinClasses(s.pageTitle, 'xlargeB')} content={content} markdown inline onClickCapture={this.onClick} key="title" />;
	}

	renderSubtitle() {
		const content = this.dynamicData?.description || this.props.data?.description;
		if (!content) return;
		return <HTML tag="h2" class={s.pageSubtitle} content={content} markdown inline key="subtitle" />;
	}
}
